//@flow
import React from 'react';
import EmailForm from '../../Homepage/components/EmailForm.react';
import CustomerActions from '../../Actions/customer';

type Props = {
  onSubmit?:(email:string) => void,
  showSignIn:() => void,
};

export default class MagicLinkForm extends React.PureComponent<Props> {
  sendMagicLink = (email:string) => {
    CustomerActions.sendMagicLink(email);
    if (this.props.onSubmit) this.props.onSubmit(email);
  }

  render() {
    return (
      <div className="reset-container magiclink-form">
        <h2 className="reset-header">SIGN IN LINK</h2>
        <div className="magiclink-desc">
          Don’t know your password? That’s fine, we can email you a link that will sign you in automatically.
        </div>
        <EmailForm
          text={"Send me a sign in link"}
          onSubmit={this.sendMagicLink}
        />
        <a className="back-to-signin" onClick={this.props.showSignIn}>Or sign in with a password</a>
      </div>
    );
  }

}
